/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Card, Stack, Typography } from '@mui/material';
import { formatDate } from '@/utils/constants';
import BrokerAvatar from '@/components/BrokerAvatar';
import { safelyParseDate } from '@/utils/date';

export const NameChangeActivityCard = ({ activity }) => {
	const createdDate = useMemo(
		() => safelyParseDate(activity?.data?.createdDate),
		[activity?.data?.createdDate],
	);

	return (
		<Card sx={{ marginBottom: '12px', borderRadius: '4px', boxShadow: 1, p: '1em' }}>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<Typography component='div' variant='task_body'>
					<Stack direction='row' alignItems='center'>
						<span style={{ fontWeight: 'bold', marginRight: 6 }}>
							{'Client name changed'}
						</span>
						<span style={{ marginRight: 6 }}>{' by '}</span>
						<BrokerAvatar
							broker={activity?.data?.completedBy}
							width='1em'
							height='1em'
							sx={{ marginRight: '0.25em !important' }}
						/>
						{activity?.data?.completedBy?.name}
						<span style={{ margin: '0 0.5em' }}>{' | '}</span>
						<span style={{ fontWeight: '500' }}>{formatDate(createdDate, true)}</span>
					</Stack>
				</Typography>
			</div>
			<div style={{ marginTop: 2, marginBottom: 20 }}>
				<Typography variant='task_body'>
					<span style={{ fontWeight: 'bold' }}>{'From '}</span>
					<span>{`${activity?.data?.originalName}`}</span>
					<span style={{ fontWeight: 'bold' }}>{' to '}</span>
					<span>{activity?.data?.newName}</span>
				</Typography>
			</div>
		</Card>
	);
};
